import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import Header from "../../../component/organisms/header";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Sidebar from "../../../component/organisms/sidebar";
import DetailTop from "../../../component/atoms/layout/detail/detailTop";
import DetailPage from "../../../component/atoms/layout/detail/detailPage";
import DetailPageTitle from "../../../component/atoms/text/detail/detailPageTitle";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import GoBack from "../../../component/molecules/goBack";
import EditBtn from "../../../component/atoms/button/editBtn";
import DetailPageForm from "../../../component/atoms/layout/detail/detailPageForm";
import DetailFormTitle from "../../../component/atoms/text/detail/detailFormTitle";
import DetailFormText from "../../../component/atoms/text/detail/detailFormText";
import { toast } from "react-toastify";
import { toastMsg } from "../../../util/toastMsg";
import { errorHandler } from "../../../util/error-handler";
import { route } from "../../../router/route";
import DelBtn from "../../../component/atoms/button/delBtn";
import Modal from "../../../component/templates/Modal";
import { modalMsg } from "../../../util/modalMsg";
import moment from "moment";
import Table from "../../../component/atoms/layout/table/table";
import Tr from "../../../component/atoms/layout/table/tr";
import Th from "../../../component/atoms/layout/table/th";
import ThText from "../../../component/atoms/text/table/thText";
import Td from "../../../component/atoms/layout/table/td";
import TdText from "../../../component/atoms/text/table/tdText";
import DetailBtn from "../../../component/atoms/button/detailBtn";
import Pagenation from "../../../component/molecules/pagenation";
import AcademyApi from "../../../api/academyApi";
import MemberApi from "./../../../api/memberApi";
import FileImgPreview from "../../../component/molecules/fileImgPreview";

function ChildDetail(props) {
  const navigate = useNavigate();
  let { id } = useParams();
  const { page } = useParams();

  const [delModalOpen, setDelModalOpen] = useState(false);

  const [data, setData] = useState({});

  const [pagination, setPagination] = useState({
    size: 10, // 한 페이지에 표시될 게시글 수
    rangeSize: 5, // 하단 페이지 사이즈

    totalCount: 0,
    totalPages: 0,
    first: false,
    last: false,
  });
  const [list, setList] = useState([]);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      const response = (await MemberApi.GetById(id)).data.data;
      setData(response);
    } catch (error) {
      errorHandler(error);
    }
  };

  useEffect(() => {
    getMemberList();
  }, [page]);

  const getMemberList = async () => {
    try {
      const data = {
        page: page - 1,
        size: pagination.size,
      };
      const list = (await AcademyApi.getChildAcademy(id, data)).data.data;
      setList(list.content);

      setPagination({
        ...pagination,
        totalCount: list.totalElements,
        totalPages: list.totalPages,
        first: list.first,
        last: list.last,
      });
    } catch (error) {
      errorHandler(error);
    }
  };

  const deleteFunc = async () => {
    try {
      await MemberApi.Del(id);
      toast(toastMsg.delete);
      setDelModalOpen(false);
      navigate(-1);
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout>
        <Sidebar />
        <DetailPageLayout>
          <DetailTop>
            <GoBack />
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <DelBtn onClick={() => setDelModalOpen(true)} />
              <EditBtn
                onClick={() => {
                  navigate(route.member_child_edit + `/${id}`);
                }}
              />
            </div>
          </DetailTop>

          <DetailPage style={{ minHeight: "268px", marginBottom: "20px" }}>
            <DetailPageTitle>기본정보</DetailPageTitle>
            <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
              <DetailPageForm>
                <DetailFormTitle>이름</DetailFormTitle>
                <DetailFormText>{data.name}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>성별</DetailFormTitle>
                <DetailFormText>{data.genderTitle}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>생년월일</DetailFormTitle>
                <DetailFormText>
                  {data.birth}-{data.gender}
                </DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>이메일</DetailFormTitle>
                <DetailFormText>{data.email}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>주소</DetailFormTitle>
                <DetailFormText>
                  {data.address}
                  <br />
                  {data.addressDetail}
                </DetailFormText>
              </DetailPageForm>
              <DetailPageForm style={{ alignItems: "flex-start" }}>
                <DetailFormTitle>이미지</DetailFormTitle>
                <FileImgPreview
                  fileUrl={data.fileUrl}
                  originFileName={data.originFileName}
                  serverFileName={data.serverFileName}
                />
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>닉네임</DetailFormTitle>
                <DetailFormText>{data.nickName}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>소개글</DetailFormTitle>
                <DetailFormText>{data.intro}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>등록 보호자 유저 계정</DetailFormTitle>
                <DetailFormText>{data.parentInfo?.email}</DetailFormText>
              </DetailPageForm>
            </div>
          </DetailPage>
          <DetailPage style={{ minHeight: "794px" }}>
            <DetailPageTitle>등록된 학원 정보 {pagination.totalCount}</DetailPageTitle>
            <Table
              style={{
                width: "964px",
              }}
            >
              <colgroup>
                <col width="277px" />
                <col width="156px" />
                <col width="164px" />
                <col width="258px" />
                <col width="110px" />
              </colgroup>
              <thead>
                <Tr style={{ height: "41px", background: "#f2f4f5" }}>
                  <Th style={{ paddingLeft: "36px" }}>
                    <ThText>학원명</ThText>
                  </Th>
                  <Th>
                    <ThText>주소</ThText>
                  </Th>
                  <Th>
                    <ThText>시간</ThText>
                  </Th>
                  <Th>
                    <ThText>결제주기/결제일자/종료일자/결제금액</ThText>
                  </Th>
                  <Th>
                    <ThText style={{ textAlign: "center", paddingRight: "48px" }}>더보기</ThText>
                  </Th>
                </Tr>
              </thead>
              <tbody>
                {list.map((item, index) => {
                  return (
                    <Tr style={{ height: "57px", background: "#fff" }} key={index}>
                      <Td>
                        <TdText
                          style={{
                            paddingLeft: "36px",
                            width: "181px",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            wordBreak: "break-all",
                          }}
                        >
                          {item.academy?.academyName}
                        </TdText>
                      </Td>
                      <Td>
                        <TdText
                          style={{
                            width: "207px",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            wordBreak: "break-all",
                          }}
                        >
                          {item.academy?.address}
                          <br />
                          {item.academy?.addressDetail}
                        </TdText>
                      </Td>
                      <Td>
                        <TdText>
                          {item.startTime}
                          <br />
                          {item.endTime}
                        </TdText>
                      </Td>
                      <Td>
                        <TdText
                          style={{
                            width: "200px",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            wordBreak: "break-all",
                          }}
                        >
                          {item.payCycleTitle ? item.payCycleTitle : "-"}/
                          {item.payDate ? item.payDate : "-"}/<br />
                          {item.payCycleEndDate ? item.payCycleEndDate : "-"}/
                          {item.amount ? item.amount : "-"}
                        </TdText>
                      </Td>
                      <Td>
                        <div
                          style={{
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            paddingRight: "48px",
                          }}
                        >
                          <DetailBtn
                            onClick={() => navigate(route.academy_detail + `/${item.academyId}/1`)}
                          />
                        </div>
                      </Td>
                    </Tr>
                  );
                })}
              </tbody>
            </Table>
            <Pagenation
              style={{ width: "964px" }}
              route={route.member_child_detail + `/${id}`}
              params={`${id}`}
              queryString={``}
              currentPage={page}
              totalPages={pagination.totalPages}
              rangeSize={pagination.rangeSize}
              first={pagination.first}
              last={pagination.last}
            />
          </DetailPage>
        </DetailPageLayout>
      </MainLayout>
      {delModalOpen ? (
        <Modal
          title={modalMsg.delete?.title}
          text={modalMsg.delete?.content}
          btnTitle={"삭제하기"}
          setModalOpen={setDelModalOpen}
          onClick={() => {
            deleteFunc();
          }}
        />
      ) : (
        ""
      )}
    </>
  );
}

export default ChildDetail;
